import { config } from '@/configs/configPortal';
import { getVersionSlugged } from '@/helpers/utils';
import { ResultButtonsProps } from '@/interfaces/result';
import CtaDispatch from '../cta-dispatch.component';
import './result-buttons.scss';

export function ResultButtons({ type, state, brand, model, year, version }: ResultButtonsProps) {
    const currentUrl = config.urlWebApp;

    let offersUrl: string;
    if (type === 'carros' && version) {
        offersUrl = `${currentUrl}${type}/${state}/${brand}/${model}/${getVersionSlugged(version)}/de.${year}?tipoveiculo=${type}&marca1=${brand}&modelo1=${model}&versao1=${getVersionSlugged(version)}&anode=${year}&page=1`;
    } else {
        offersUrl = `${currentUrl}${type}/${state}/${brand}/${model}/de.${year}?tipoveiculo=${type}&marca1=${brand}&modelo1=${model}&anode=${year}&page=1`;
    }

    return (
        <div className="result-buttons__container" data-testid="result-buttons-container" id="result-buttons-container">
            <p data-testid="result-buttons-text"> Deseja vender {type === 'carros' ? `este carro` : 'esta moto'} ou ver ofertas similares?</p>
            <div className="result-buttons" data-testid="result-buttons">
                <CtaDispatch
                    interaction={type === 'carros' ? "vender-meu-carro-resultado" : "vender-minha-moto-resultado"}
                    href={type === 'carros' ? `${currentUrl}vender-carro` : `${currentUrl}vender-moto`}
                    className="btn btn__default"
                    dataTestId="sell-button"
                    id="sell-button"
                >
                    Vender {type === 'carros' ? 'meu carro' : 'minha moto'}
                </CtaDispatch>
                <CtaDispatch
                    interaction='ver-ofertas-resultado'
                    href={offersUrl}
                    className="btn btn__secondary"
                    dataTestId="offers-button"
                    id="offers-button"
                >
                    Ver ofertas
                </CtaDispatch>
            </div>
        </div>
    );
}